import React from "react"

import {
  prefetchLenderUsersListQuery,
  useLenderUsersList,
} from "@boundless/bl-api-client/lender/services"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { RefreshCwIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { InviteUserDialog } from "@/components/users/InviteUserDialog"
import { LenderUserProvider } from "@/components/users/providers/UserProvider"
import { FallbackUserTable, UserTable } from "@/components/users/UserTable"
import { cn } from "@/lib/utils"

export const Route = createFileRoute("/_dashboard/lender/users")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["users.view_lenderuser"])) {
      throw redirect({ to: "/" })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    prefetchLenderUsersListQuery(queryClient)
  },
})

function RouteComponent() {
  const { refetch, isFetching } = useLenderUsersList()
  return (
    <Card>
      <CardHeader className="flex flex-row justify-between">
        <CardTitle>Users</CardTitle>
        <Button
          className="h-8 min-w-8"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          <RefreshCwIcon className={cn(isFetching && "animate-spin")} />
        </Button>
      </CardHeader>
      <LenderUserProvider>
        <CardContent>
          <React.Suspense fallback={<FallbackUserTable />}>
            <UserTable />
          </React.Suspense>
        </CardContent>
        <CardFooter className="justify-right">
          <InviteUserDialog />
        </CardFooter>
      </LenderUserProvider>
    </Card>
  )
}
